var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-bg min-vh-100 vw-100 top-0 left-0 right-0 position-absolute d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"container",staticStyle:{"z-index":"2"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }